import { BaseRebalancingQueryDto } from './base-rebalancing-query.dto';
import { Address } from '@31third/common';

export class RebalancingEnzymeVaultQueryDto extends BaseRebalancingQueryDto {
  vault: Address;
  testnet?: boolean;
}
